import React from 'react';
const navigation = [{
  name: 'El video',
  href: '#vsl'
}, {
  name: 'Diagnóstico gratuito',
  href: '#calificar'
}, {
  name: 'Resultados de clientes',
  href: '#resultados'
}];
export function Footer() {
  return <footer className="bg-ink-900 pt-16 pb-28 md:pb-12 border-t border-white/10 px-4 sm:px-6 lg:px-8" data-id="element-8" data-mp="32pp39tivff18">
      <div className="max-w-7xl mx-auto" data-id="element-9" data-mp="36nd6djupwe47">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 pb-12" data-id="element-10" data-mp="3ueigrjhw2e74">
          {/* Brand */}
          <div className="md:col-span-5" data-id="element-11" data-mp="38zbozae1d6l">
            <div className="inline-flex flex-col items-center leading-none mb-5" data-id="element-12" data-mp="37xv6falryhh">
              <span className="text-xl font-normal tracking-[0.4em] text-white pl-[0.4em]" data-id="element-13" data-mp="3ldu4ouc22nwv">
                VANTIX
              </span>
              <span className="text-[9px] font-medium tracking-[0.3em] text-white/80 border-t border-gold pt-1.5 mt-1.5 w-full text-center pl-[0.3em]" data-id="element-14" data-mp="29z6tk9nn6feu">
                CREDIT SOLUTIONS
              </span>
            </div>
            <p className="text-white/70 font-normal leading-relaxed text-sm max-w-sm" data-id="element-15" data-mp="3l90ntw47myz9">
              Restauramos perfiles de crédito y estructuramos el acceso a
              financiamiento personal y empresarial en Estados Unidos y Puerto
              Rico.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3" data-id="element-16" data-mp="3q7llbns2v4k0">
            <h2 className="text-[11px] font-semibold tracking-[0.18em] uppercase text-white/40 mb-4" data-id="element-17" data-mp="3qazr75zy9vw7">
              Navegación
            </h2>
            <ul className="space-y-2.5" data-id="element-18" data-mp="34p834h8zogo">
              {navigation.map(item => <li key={item.name} data-id="element-19" data-mp="htd2h7fcxs51">
                  <a href={item.href} className="text-sm text-white/75 hover:text-white transition-colors" data-id="element-20" data-mp="hsabkzi1bpp4">
                    {item.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4" data-id="element-21" data-mp="mtraipgyl232">
            <h2 className="text-[11px] font-semibold tracking-[0.18em] uppercase text-white/40 mb-4" data-id="element-22" data-mp="tvmrhl25amnh">
              Contacto
            </h2>
            <ul className="space-y-2.5" data-id="element-23" data-mp="yupjo4x10ye1">
              <li data-id="element-24" data-mp="13tansffeg27r">
                <a href="tel:+14073678672" className="text-sm text-white/75 hover:text-white transition-colors" data-id="element-25" data-mp="13sr6n0xkphus">
                  +1 (407) 367-8672
                </a>
              </li>
              <li data-id="element-26" data-mp="1cl2wakkv519p">
                <a href="mailto:eduardo@vantixcreditsolutions.com" className="text-sm text-white/75 hover:text-white transition-colors" data-id="element-27" data-mp="1cnyr401ez9tx">
                  eduardo@vantixcreditsolutions.com
                </a>
              </li>
              <li className="text-sm text-white/70" data-id="element-28" data-mp="1ri3mukrbiq6l">
                Servicio 100% remoto · Lunes a viernes
              </li>
            </ul>
          </div>
        </div>

        {/* Disclosure */}
        <div className="pt-8 border-t border-white/10" data-id="element-29" data-mp="3tai21c2h9gjb">
          <p className="text-xs leading-relaxed text-white/55 max-w-3xl" data-id="element-30" data-mp="2afn76wxgt9sw">
            Vantix Credit Solutions no es un bufete de abogados ni una agencia
            de reporte crediticio. Los resultados varían según el perfil de cada
            cliente y no están garantizados salvo lo establecido por escrito en
            el contrato de servicio. Usted tiene derecho a disputar información
            inexacta en su reporte de crédito por su cuenta y sin costo alguno.
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-white/35" data-id="element-31" data-mp="2pc4khtp7syi3">
          <p data-id="element-32" data-mp="2kf4efisd7vqz">
            © {new Date().getFullYear()} Vantix Credit Solutions. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-6" data-id="element-33" data-mp="18yeg0lu6o87x">
            <a href="#" className="hover:text-white/70 transition-colors" data-id="element-34" data-mp="18zfqop7aesp4">
              Privacidad
            </a>
            <a href="#" className="hover:text-white/70 transition-colors" data-id="element-35" data-mp="1414ew8xfm849">
              Términos
            </a>
          </div>
        </div>
      </div>
    </footer>;
}